<template>
<div class="panelNagusia">
  <h1 class="ui header"><img class="ui image" src="../../assets/logo.png">
    <div class="content">Incidencias</div>
  </h1>

  <div class="ui stackable">
    <div class="row">
      <h4 class="ui dividing header">Buscar un paquete</h4>
      <div class="ui error message" v-show="error"> {{ errorText }}</div>
      <filterMaster :theRole="role" :theSearch="search" @filtersSelected="searchParcel"></filterMaster>
    </div>

    <div v-if="searching && rows.length==0" class="ui active centered inline loader"></div>
    <div v-if="rows.length!=0" class="row">
      <div class="column">
        <h4 class="ui dividing header">Los últimos movimientos</h4>
        <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
                perPage: 50,
                enabled: true,
                mode: 'pages'
                }" :sort-options="{
                enabled: true,
                initialSortBy: {field: 'lastUpdate', type: 'desc'}
                }"
          @on-row-click="troubleshootingInfo" styleClass="vgt-table striped condensed bordered">
          >
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import filterMaster from '@/components/filterMaster.vue'
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'troubleshooting',
  data() {
    return {
      searching: null,
      error: false,
      errorText: null,
      apmOptions: null,
      role: null,
      search: {
        'phone': null,
        'codigo': null,
        'apm': null,
        'multiorder_code': null,
      },
      rows: [],
      columns: []
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role;
    this.searching = false;
    this.errorText = '';

    if (this.role === 'sabico' || this.role === 'master' || this.role === 'admin') {
      this.columns = [
        {
          label: 'APM',
          field: 'apm',
        },
        {
          label: 'Teléfono',
          field: 'phone',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Estado',
          field: 'status',
        },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          width: '120px',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
        }
      ]
    } else if (this.role === 'cau') {
      this.columns = [
        {
          label: 'APM',
          field: 'apm',
        },
        {
          label: 'Teléfono',
          field: 'phone',
        },
        {
          label: 'Nº Pedido',
          field: 'multiorder_code',
        },
        {
          label: 'Bultos',
          field: 'multiorder_count',
        },
        {
          label: 'Estado',
          field: 'status',
        },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          width: '120px',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
        }
      ] 
    }
  },
  methods: {
    searchParcel(filtersSelected) {
      this.searching = true
      this.rows = []

      this.search = JSON.parse(JSON.stringify(filtersSelected));

      if (Object.keys(this.search).filter((element) => this.search[element]).length === 0) {
        this.searching = false
        this.error = true
        this.errorText= 'Debe introducir algún criterio de búsqueda.'
      } else {
        this.error = false
        hapiickApi().post('/v4/shipments/search', {
          admin_id: JSON.parse(localStorage.admin).id,
          search: this.search
        })
        .then(request => this.updateTable(request))
        .catch((request) => console.log('error getting parcels:' + request))
      }
    },
    updateTable(req) {
      let parcels = []
      parcels = JSON.parse(JSON.stringify(req.data.data.parcels))

      if (parcels.length == 0) {
        this.rows.push({
          'apm': 'no encontrado',
        })
      }
      for (var i in parcels) {
        let status = 'INDEFINIDO'
        let element = parcels[i]
        if (element.status == "CREATE" || element.status == "new") {
          status = 'PENDIENTE INTRODUCIR EN ARMARIO'
        } else if (element.status == "OPERIN" || element.status == "in-apt") {
          status = 'EN ARMARIO'
        } else if (element.status == "OPEROUT" || element.status == "to-term") {
          status = 'RETIRADO POR MENSAJERO'
        } else if (element.status == "RECEIVE" || element.status == "delivered") {
          status = 'RECOGIDO POR DESTINATARIO'
        }

        this.rows.push({
          'from': element.from,
          'apm': element.apm,
          'phone': element.phone,
          'email': element.email,
          'multiorder_code': element.multiorder_code,
          'multiorder_count': (element.multiorder_code) ? element.multiorder_count+ '/'+element.total_bultos : '',
          'status': status,
          'lastUpdate': element.lastUpdate,
          'id': element.id
        })
      }
    },
    troubleshootingInfo(params) {
      let routeData = this.$router.resolve('/troubleshooting/info/' + params.row.from + '/' + params.row.id);
      window.open(routeData.href, '_blank');
    },
    goTo(where) {
      this.$router.push(where)
    },
  },
  components: {
    'filterMaster': filterMaster
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Troubleshooting/troubleshooting.vue